/**
 * Iter XX.273 — Continue This Journey · purchase-origin stash.
 *
 * Mirrors XX.272's challenge-origin roundtrip:
 *   stash(focusText)      before beginPlusPurchase kicks off
 *   consume()             once, from Upgrade post-success handler
 *   peek()                read-only
 *
 * Stored under a distinct localStorage key so XX.272 challenge
 * origins never collide with XX.273 journey origins. Both are
 * expired after 24h so a stale stash never hijacks an unrelated
 * future purchase.
 *
 * Upgrade.jsx redirect ladder consumes challenge-origin FIRST, then
 * journey-origin, then falls back to /chat. That precedence is
 * deliberate — an active Challenge purchase must never be masked
 * by a stale journey stash.
 */

const KEY = "gully_journey_origin_v1";
const TTL_MS = 24 * 3600 * 1000;

export function stashJourneyOrigin({ focusText } = {}) {
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ focus_text: focusText || null, at: Date.now() }),
    );
  } catch { /* noop */ }
}

export function consumeJourneyOrigin() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    localStorage.removeItem(KEY);
    const p = JSON.parse(raw);
    if (!p) return null;
    if (typeof p.at === "number" && Date.now() - p.at > TTL_MS) {
      return null;
    }
    return { focus_text: p.focus_text || null };
  } catch {
    return null;
  }
}

export function peekJourneyOrigin() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p) return null;
    if (typeof p.at === "number" && Date.now() - p.at > TTL_MS) {
      return null;
    }
    return { focus_text: p.focus_text || null };
  } catch {
    return null;
  }
}
